import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { SellerImportModel } from 'src/app/models/imports/seller-import-model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { SellerUpdateDocumentModel } from './../../models/archive/seller-update-document.model';
import { SellerModel } from './../../models/archive/seller.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class SellerService {

  constructor(private _httpClient: HttpClient) { }

  createSeller(SellerContract: SellerModel): Observable<SellerModel> {
    return this._httpClient.post<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.CreateSeller}`,
      SellerContract);
  }

  deleteSeller(sellerId: number): Observable<SellerModel> {
    return this._httpClient.delete<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.DeleteSeller}/${sellerId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.seller.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllSellersForSelectByBranchIdAsync(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetAllSellersForSelectByBranchIdAsync}/${branchId}`);
  }

  getAllSellersForRegisterAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetAllSellersForRegisterAsync}`);
  }

  getAllSellersWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetAllSellersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllTypeDocumentsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetAllTypeDocumentsForSelectAsync}`);
  }

  getAllUserByBranchIdForSelectAsync(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetAllUserByBranchIdForSelectAsync}`,
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetColumnsForGeneralConsultationAsync}`);
  }

  getCityDepartment(cityId: number): Observable<string> {
    const params = new HttpParams().set('cityId', cityId);
    return this._httpClient.get<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetCityDepartmentAsync}`,
      { params: params }
    );
  }

  getCitiesForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetCitiesForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForCitiesSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetColumnsForCitiesSelectionAsync}`);
  }

  getDigitVerification(document: string): Observable<number> {
    const itemFilterResponse = new ItemFilterModel("document", null, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetDigitVerification}`, itemFilterResponse);
  }

  GetSellerByBranchId(branchId: number): Observable<Array<SellerModel>> {
    return this._httpClient.get<Array<SellerModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetSellerByBranchId}/${branchId}`)
  }

  getSellerByCostCenterId(costCenterId: number): Observable<SellerModel> {
    return this._httpClient.get<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetSellerByCostCenterId}/${costCenterId}`)
  }

  getSellerByDocumentAsync(branchId: number, document: string): Observable<SellerModel> {
    const itemFilterResponse = new ItemFilterModel("document", branchId, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetSellerByDocumentAsync}`, itemFilterResponse)
  }

  getSellerById(sellerId: number): Observable<SellerModel> {
    return this._httpClient.get<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetSellerById}/${sellerId}`);
  }

  getSellerByName(branchId: number, name: string): Observable<SellerModel> {
    const itemFilterResponse = new ItemFilterModel("name", branchId, null, "");
    itemFilterResponse.wildcard = name;
    return this._httpClient.post<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.GetSellerByName}`, itemFilterResponse)
  }

  setActiveSeller(sellerId: number): Observable<SellerModel> {
    return this._httpClient.put<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.SetActiveSeller}/${sellerId}`,
      null);
  }

  importSellers(sellerImports: Array<SellerImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.ImportSeller}`, sellerImports);
  }

  updateSeller(SellerContract: SellerModel): Observable<SellerModel> {
    return this._httpClient.put<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.UpdateSeller}`,
      SellerContract);
  }

  updateSellerDocument(SellerContract: SellerUpdateDocumentModel): Observable<SellerModel> {
    return this._httpClient.put<SellerModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.seller.UpdateSellerDocument}`,
      SellerContract);
  }
}